import type { Dispatch, SetStateAction } from 'react';
import { useLayoutEffect, useState } from 'react';

/**
 * Автообновляемый стейт. При передаче нового value значение автоматически обновляется.
 * @param value значение
 * @returns значение стейта и функция обновления
 */
export const useUpdatableState = <T>(value: T): [T, Dispatch<SetStateAction<T>>] => {
    const [realValue, setValue] = useState(value);

    useLayoutEffect(() => {
        setValue(value);
    }, [value]);

    return [realValue, setValue];
};
